
import defaultGroupsForm from "@/util/DatabaseManagement/Auth/defaultGroupsForm.js"
import defaultPermissionsForm from "@/util/DatabaseManagement/Auth/defaultPermissionsForm.js"

import axios from "axios"
import qs from "qs"
import { clone, objectCamelToSnakeCase, objectSnakeToCamelCase, deleteKeyNullValues, removeEmpty } from "@/util/libUtil.js"

const state = {
    groups: {
        form: clone(defaultGroupsForm),
        type: 'CREATE',
        isLoading: false,
        isOpenGroupsView: false,
        isOpen: false,
        groups: []
    },
    permissions: {
        form: clone(defaultPermissionsForm),
        type: 'CREATE',
        isLoading: false,
        isOpenPermissionsView: false,
        isOpen: false,
        permissions: []
    },

    clicksToTenant: 0,
    paths: {
        groupsPath: '/api/groups/',
        permissionsPath: '/api/permissions/',
    }
}

const mutations = {
    groups(state, val) {
        state.groups.groups = clone(val)
    },
    groupsLoading(state, val) {
        state.groups.isLoading = val
    },
    groupsForm(state, val) {
        state.groups.form = clone(val)
    },
    groupsType(state, val) {
        state.groups.type = val
    },
    isOpenGroupsView(state, val) {
        state.groups.isOpenGroupsView = val
    },
    isOpenGroupsSummary(state, val) {
        state.groups.isOpen = val
    },

    permissions(state, val) {
        state.permissions.permissions = clone(val)
    },
    permissionsLoading(state, val) {
        state.permissions.isLoading = val
    },
    permissionsForm(state, val) {
        state.permissions.form = clone(val)
    },
    permissionsType(state, val) {
        state.permissions.type = val
    },
    isOpenPermissionsView(state, val) {
        state.permissions.isOpenPermissionsView = val
    },
    isOpenPermissionsSummary(state, val) {
        state.permissions.isOpen = val
    },
}

const actions = {
    async fetchGroups({ state, commit, getters }) {
        try {
            const res = await axios.get(getters.getEndpointFromPath(state.paths.groupsPath))
            commit('groups', res.data)

        } catch (error) {
            console.log(error)
        }
    },
    async deleteGroups({ state, getters, dispatch, commit }, id) {
        try {
            let resp = await axios.delete(`${getters.getEndpointFromPath(state.paths.groupsPath)}${id}/`)
            dispatch('fetchGroups', {})
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Credenciales Borrado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Borrar el Credenciales',
            }, { root: true })
        }
    },
    async createGroups({ getters, state, dispatch, commit }) {
        try {
            await axios.post(getters.getEndpointFromPath(state.paths.groupsPath), state.groups.form)
            dispatch('fetchGroups', {})
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Credenciales Creado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al crear Credenciales',
            }, { root: true })
        }
    },
    async updateGroups({ getters, state, dispatch, commit }) {
        try {
            await axios.put(`${getters.getEndpointFromPath(state.paths.groupsPath)}${state.groups.form.id}/`, deleteKeyNullValues(state.groups.form))
            dispatch('fetchGroups', {})
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Credenciales Creado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al crear Credenciales',
            }, { root: true })
        }
    },

    async fetchPermissions({ state, commit, getters }) {
        try {
            const res = await axios.get(getters.getEndpointFromPath(state.paths.permissionsPath))
            commit('permissions', res.data)

        } catch (error) {
            console.log(error)
        }
    },
    async deletePermissions({ state, getters, dispatch, commit }, id) {
        try {
            let resp = await axios.delete(`${getters.getEndpointFromPath(state.paths.permissionsPath)}${id}/`)
            dispatch('fetchPermissions', {})
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Credenciales Borrado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Borrar el Credenciales',
            }, { root: true })
        }
    },
    async createPermissions({ getters, state, dispatch, commit }) {
        try {
            await axios.post(getters.getEndpointFromPath(state.paths.permissionsPath), state.groups.form)
            dispatch('fetchPermissions', {})
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Credenciales Creado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al crear Credenciales',
            }, { root: true })
        }
    },
    async updatePermissions({ getters, state, dispatch, commit }) {
        try {
            await axios.put(`${getters.getEndpointFromPath(state.paths.permissionsPath)}${state.groups.form.id}/`, deleteKeyNullValues(state.groups.form))
            dispatch('fetchPermissions', {})
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Credenciales Creado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al crear Credenciales',
            }, { root: true })
        }
    },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    )
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}